<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <span class=" mr-auto">
    <button mat-raised-button routerLink="/sites" class="m-1 mr-2">
      <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('sites.plural', 'Sites') }}
    </button>

    <button mat-raised-button *ngIf="child_id" [routerLink]="'/sites/'+parent_id+'/children'" class="m-1 mr-2">
      <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('child-sites.plural', 'Subsites') }}
    </button>

    <button mat-raised-button [routerLink]="utils.prepareSiteRelatedLink(site_id, child_id ? parent_id : null, 'view/emergency-evacuation-plans')" *ngIf="site.id" class="m-1 mr-2">
      <mat-icon>visibility</mat-icon> View
    </button>

    <button mat-raised-button class="m-1 mr-2" (click)="onExportEmergencyEvacuationPlan()">
      <mat-icon>cloud_download</mat-icon> Export
    </button>
  </span>
</nav>

<mat-tab-group class="bg-white">
  <mat-tab label="Emergency Evacuation Plan">

    <form #f="ngForm" class="form-container" (ngSubmit)="onSubmit()">
      <div class="card">
        <div class="card-body">

          <div class="container-fluid p-0">
            <div class="row">
              <div class="col">

                <h6 class="mb-4">Emergency Numbers & Locations</h6>

                <app-phone-input
                  [idInput]="phone_input_id['emergency']"
                  [numberInput]="site.emergency_phone"
                  [countryCodeInput]="site.emergency_phone_country_code"
                  [dialCodeInput]="site.emergency_phone_dial_code"
                  [e164NumberInput]="site.emergency_phone_e164"
                  (phoneDetailsOutput)="getOutputPhoneDetails($event, 'emergency')"
                  [labelInput]="'Emergency Number'"
                  [hintInput]="'Enter the emergency number e.g. 111, 911, 999, 10111 depending on the country you are in.'"
                  required="false">
                </app-phone-input>

                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Hospital Address</mat-label>
                  <input matInput placeholder="Hospital Address"
                         [(ngModel)]="site.hospital_address"
                         name="hospital_address" type="text" id="hospital_address"
                         matTooltip="E.g. 124 Shakespeare Rd, Takapuna, Auckland 0620."/>
                  <mat-hint>Enter the address of the nearest hospital.</mat-hint>
                </mat-form-field>

                <app-phone-input
                  [idInput]="phone_input_id['hospital']"
                  [numberInput]="site.hospital_phone"
                  [countryCodeInput]="site.hospital_phone_country_code"
                  [dialCodeInput]="site.hospital_phone_dial_code"
                  [e164NumberInput]="site.hospital_phone_e164"
                  (phoneDetailsOutput)="getOutputPhoneDetails($event, 'hospital')"
                  [labelInput]="'Hospital Phone'"
                  [hintInput]="'Enter the phone number of the nearest hospital.'"
                  required="false">
                </app-phone-input>

                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Medical Centre Address</mat-label>
                  <input matInput placeholder="Medical Centre Address"
                         [(ngModel)]="site.medical_centre_address"
                         name="medical-centre-address" type="text" id="medical-centre-address"
                         matTooltip="E.g. 124 Shakespeare Rd, Takapuna, Auckland 0620."/>
                  <mat-hint>Enter the address of the nearest medical centre.</mat-hint>
                </mat-form-field>

                <app-phone-input
                  [idInput]="phone_input_id['medical_centre']"
                  [numberInput]="site.medical_centre_phone"
                  [countryCodeInput]="site.medical_centre_phone_country_code"
                  [dialCodeInput]="site.medical_centre_phone_dial_code"
                  [e164NumberInput]="site.medical_centre_phone_e164"
                  (phoneDetailsOutput)="getOutputPhoneDetails($event, 'medical_centre')"
                  [labelInput]="'Medical Centre Phone'"
                  [hintInput]="'Enter the phone number of the nearest medical centre.'"
                  required="false">
                </app-phone-input>

                <h6 class="mb-4">First Aid Kit, AED & Fire Extinguisher</h6>

                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>First Aid Kit Location</mat-label>
                  <input matInput placeholder="First Aid Kit Location"
                         [(ngModel)]="site.first_aid_kit_location"
                         name="first-aid-kit-location" type="text" id="first-aid-kit-location"
                         matTooltip="E.g. At the receptions desk."/>
                  <mat-hint>Enter the location of the first aid kits.</mat-hint>
                </mat-form-field>

                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>AED (Automated External Defibrillator) Location</mat-label>
                  <input matInput placeholder="AED (Automated External Defibrillator) Location"
                         [(ngModel)]="site.aed_location"
                         name="aed_location" type="text" id="aed_location"
                         matTooltip="E.g. At the receptions desk."/>
                  <mat-hint>Enter the location of the nearest AED.</mat-hint>
                </mat-form-field>

                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Fire Extinguisher Location</mat-label>
                  <input matInput placeholder="Fire Extinguisher Location"
                         [(ngModel)]="site.fire_extinguisher_location"
                         name="fire-extinguisher-location" type="text" id="fire-extinguisher-location"
                         matTooltip="E.g. Next to the elevators on each floor"/>
                  <mat-hint>Enter the location of the fire extinguisher.</mat-hint>
                </mat-form-field>

              </div>

              <div class="col">

                <h6 class="mb-4">Evacuation Alerts & Assembly Locations</h6>

                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Description of Alarm</mat-label>
                  <input matInput placeholder="Description of Alarm"
                         [(ngModel)]="site.alarm_description" name="alarm_description"
                         type="text" id="alarm_description"
                         matTooltip="E.g. A constant alarm sounding throughout the building."/>
                  <mat-hint>Enter a clear description of the {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} alarm.</mat-hint>
                </mat-form-field>

                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Assembly Location</mat-label>
                  <input matInput placeholder="Assembly Location"
                         [(ngModel)]="site.assembly_location" name="assembly-location"
                         type="text" id="assembly-location"
                         matTooltip="E.g. Parking lot at the corner of Como St and Auburn St."/>
                  <mat-hint>Enter the location where people should assemble during an evacuation.</mat-hint>
                </mat-form-field>

                <h6 class="mb-4">Additional Contact Numbers</h6>

                <app-phone-input
                  [idInput]="phone_input_id['worksafe']"
                  [numberInput]="site.worksafe_phone"
                  [countryCodeInput]="site.worksafe_phone_country_code"
                  [dialCodeInput]="site.worksafe_phone_dial_code"
                  [e164NumberInput]="site.worksafe_phone_e164"
                  (phoneDetailsOutput)="getOutputPhoneDetails($event, 'worksafe')"
                  [labelInput]="utils.getLangTerm('sites.emergency-evacuation-plan.labels.worksafe-phone', 'WorkSafe Phone')"
                  [hintInput]="utils.getLangTerm('sites.emergency-evacuation-plan.hints.worksafe-phone', 'Enter the phone number for WorkSafe.')"
                  required="false">
                </app-phone-input>

                <app-phone-input
                  [idInput]="phone_input_id['civil_defence']"
                  [numberInput]="site.civil_defence_phone"
                  [countryCodeInput]="site.civil_defence_phone_country_code"
                  [dialCodeInput]="site.civil_defence_phone_dial_code"
                  [e164NumberInput]="site.civil_defence_phone_e164"
                  (phoneDetailsOutput)="getOutputPhoneDetails($event, 'civil_defence')"
                  [labelInput]="utils.getLangTerm('sites.emergency-evacuation-plan.labels.civil-defence-phone', 'Civil Defence Phone')"
                  [hintInput]="utils.getLangTerm('sites.emergency-evacuation-plan.hints.civil-defence-phone', 'Enter the phone number for Civil Defence.')"
                  required="false">
                </app-phone-input>

                <app-phone-input
                  [idInput]="phone_input_id['poison_centre']"
                  [numberInput]="site.poison_centre_phone"
                  [countryCodeInput]="site.poison_centre_phone_country_code"
                  [dialCodeInput]="site.poison_centre_phone_dial_code"
                  [e164NumberInput]="site.poison_centre_phone_e164"
                  (phoneDetailsOutput)="getOutputPhoneDetails($event, 'poison_centre')"
                  [labelInput]="utils.getLangTerm('sites.emergency-evacuation-plan.labels.poison-centre-phone', 'Poison Centre Phone')"
                  [hintInput]="utils.getLangTerm('sites.emergency-evacuation-plan.hints.poison-centre-phone', 'Enter the phone number for the poison centre.')"
                  required="false">
                </app-phone-input>

                <app-phone-input
                  [idInput]="phone_input_id['power']"
                  [numberInput]="site.power_phone"
                  [countryCodeInput]="site.power_phone_country_code"
                  [dialCodeInput]="site.power_phone_dial_code"
                  [e164NumberInput]="site.power_phone_e164"
                  (phoneDetailsOutput)="getOutputPhoneDetails($event, 'power')"
                  [labelInput]="utils.getLangTerm('sites.emergency-evacuation-plan.labels.power-phone', 'Power (Customer Service) Phone')"
                  [hintInput]="utils.getLangTerm('sites.emergency-evacuation-plan.hints.power-phone', 'Enter the phone number for the power service provider.')"
                  required="false">
                </app-phone-input>

                <app-phone-input
                  [idInput]="phone_input_id['faults']"
                  [numberInput]="site.faults_phone"
                  [countryCodeInput]="site.faults_phone_country_code"
                  [dialCodeInput]="site.faults_phone_dial_code"
                  [e164NumberInput]="site.faults_phone_e164"
                  (phoneDetailsOutput)="getOutputPhoneDetails($event, 'faults')"
                  [labelInput]="utils.getLangTerm('sites.emergency-evacuation-plan.labels.faults-phone', '24Hr Faults Phone')"
                  [hintInput]="utils.getLangTerm('sites.emergency-evacuation-plan.hints.faults-phone', 'Enter the phone number where ' + utils.getLangTerm('parent-child-sites-combined.singular', 'Site') + ' faults can be reported.')"
                  required="false">
                </app-phone-input>

              </div>
            </div>

            <div class="row" appMarginBottom>
              <div class="col">
                <small><b>Note:</b> Fields that are left empty will not show to users.</small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <button mat-raised-button class="my-2 ml-0 mr-2" [disabled]="!f.valid || inProgress || getPhoneDetailsErrorState()" type="submit" color="primary">
                <mat-icon>save</mat-icon> Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

  </mat-tab>

  <mat-tab label="Safety Managers">
    <app-sites-safety-managers [site_id]="site.id" [enableEditing]="true"></app-sites-safety-managers>
  </mat-tab>

  <mat-tab label="First Aiders">
    <app-sites-first-aiders [site_id]="site.id" [enableEditing]="true"></app-sites-first-aiders>
  </mat-tab>

  <mat-tab label="Emergency Evacuation Plan Map">

    <div class="alert alert-primary" role="alert" appMargin>
      Use the following guidelines for uploading your emergency evacuation plan map:
      <ul>
        <li>It can only be a <b>PDF</b> or an <b>image</b> file.</li>
        <li>For the best image results, use an A4 scanned image of the {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site').toLowerCase() }} map.</li>
        <li>The image will be scaled to fit on a page in the A4 PDF export.</li>
        <li>If you upload a PDF document, it will be merged with the exported information.</li>
      </ul>
    </div>

    <div appMargin>
      <button mat-raised-button class="my-1 ml-0 mr-3" color="secondary" type="button" (click)="onSelectEmergencyEvacuationPlanMap()">
        <mat-icon>image</mat-icon> Select &amp; Upload Evacuation Map
      </button>

      <button mat-raised-button class="my-1 ml-0 mr-3" color="warn" type="button" (click)="onRemoveEmergencyEvacuationPlanMap($event)" *ngIf="site.evacuation_map_url">
        <mat-icon>delete</mat-icon> Remove Evacuation Map
      </button>

      <input type="file" (change)="onUploadEmergencyEvacuationPlanMap($event)" style="display: none;" #emergencyEvacuationPlanMapFileSelector />
    </div>

    <ng-container *ngIf="site.evacuation_map_url">
      <div class="container-fluid">
        <img *ngIf="utils.isImage(site.evacuation_map_url); else showPDF" [src]="site.evacuation_map_url" (click)="utils.onDownloadFromTemporaryURL(site.evacuation_map_url, 'Emergency Evacuation Plan Map.' + site.evacuation_map_url.split('.').pop(), $event)" style="cursor: pointer;" class="profile-picture" alt="Emergency Evacuation Plan Map" appMargin />
        <ng-template #showPDF>
          <mat-nav-list dense>
            <h6 matSubheader>Uploaded PDF</h6>
            <mat-list-item>
              <span matListItemTitle>Emergency Response Plan Map</span>

              <button
                matListItemMeta
                mat-icon-button
                ngxClipboard
                aria-label="Copy file URL"
                matTooltip="Copy this file URL."
                [cbContent]="site.evacuation_map_url"
                (click)="onCopiedURL()"
                class="dialog-button my-auto ml-2 mr-0"
                style="cursor: pointer;">
                <mat-icon>content_copy</mat-icon>
              </button>

              <button
                matListItemMeta
                mat-icon-button
                aria-label="Download file"
                matTooltip="Download this file."
                (click)="utils.onDownloadFromTemporaryURL(site.evacuation_map_url, 'Emergency Evacuation Plan Map.' + site.evacuation_map_url.split('.').pop(), $event)"
                class="dialog-button my-auto ml-2 mr-0"
                style="cursor: pointer;">
                <mat-icon>download</mat-icon>
              </button>

              <button
                matListItemMeta
                mat-icon-button
                aria-label="Preview file"
                matTooltip="View this file."
                (click)="onOpenUrl(site.evacuation_map_url)"
                class="dialog-button my-auto ml-2 mr-0"
                style="cursor: pointer;">
                <mat-icon>preview</mat-icon>
              </button>
            </mat-list-item>
          </mat-nav-list>
        </ng-template>
      </div>
    </ng-container>

  </mat-tab>
</mat-tab-group>


